/**
 * Errori di collegamento nel passo 2FA: la richiesta non e' arrivata al server, quindi il messaggio
 * del browser ("Failed to fetch (core.flusia.it)", "Load failed", "NetworkError ...") non dice niente
 * all'utente. Lo si sostituisce con un testo chiaro e qualche cosa da provare.
 *
 * Caso reale (23/10/2026): l'indirizzo di un utente era nella lista anti-bot del firewall del server,
 * la richiesta del codice riceveva la pagina di controllo e il browser mostrava solo "Failed to fetch".
 */

const CONNECTION_PATTERNS = [
  'failed to fetch',
  'load failed',
  'networkerror',
  'network request failed',
  'network error',
  'failed to send a request to the edge function',
  'core call failed',
];

/** True se l'errore dice che la richiesta non e' arrivata al server (rete, firewall, estensioni), non che il codice e' sbagliato. */
export function isConnectionError(err: unknown): boolean {
  if (!err) return false;
  const e = err as { code?: unknown; name?: unknown; message?: unknown };
  if (e.code === 'network_error' || e.name === 'FunctionsFetchError') return true;
  const message = (typeof err === 'string' ? err : typeof e.message === 'string' ? e.message : '').toLowerCase();
  return CONNECTION_PATTERNS.some((p) => message.includes(p));
}

export const CONNECTION_ERROR_MESSAGE = {
  send: 'Non riusciamo a raggiungere il server per inviarti il codice.',
  verify: 'Non riusciamo a raggiungere il server per verificare il codice.',
} as const;

/** Cosa provare, dalla cosa piu' semplice alla piu' rara. Breve: sta sotto il campo del codice. */
export const CONNECTION_ERROR_TIPS = [
  'Ricarica la pagina e riprova.',
  'Se usi una VPN o una rete aziendale o pubblica, disattivala o prova con un\'altra rete (anche l\'hotspot del telefono).',
  'Disattiva per un momento blocchi pubblicitari ed estensioni del browser su Flusia.',
  'Se hai salvato i codici di emergenza, puoi entrare con uno di quelli qui sotto.',
] as const;

export const SUPPORT_EMAIL = 'support@flusia.it';
